export default {
    echarts: {
        day: 'Day',
        week: 'Week',
        month: 'Month',
        startDate: 'Start Date',
        endDate: 'End Date',
        moreEcharts: 'More Echarts',
        app: 'Agents',
        workFlow: 'Workflows',
        content: 'Content',
        activeDistribution: 'Chat Activity Heat Map',
        activeDistributionTip: 'Monthly conversation activity distribution chart (the darker the color, the more conversations)',
        selectApp: 'Select Agent',
        to: 'To',
        date: 'Date:',
        conversationNumber: 'Chat Count',
        channelConversationNumber: 'Channel Chat Count',
        channelConversationNumberTip: 'The number of conversations in different usage channels within the cycle and the proportion of the number of conversations',
        hosting: 'Hosting',
        selfBuilding: 'Self Building',
        other: 'Other',
        conversationNumberTip: 'Chat Count',
        proportion: 'Proportion:',
        cumulativeConversation: 'Cumulative Chat',
        conversationChannel: 'Conversation Channel',
        highFrequencyWords: 'High Frequency Words',
        highFrequencyWordsTip: 'High frequency keywords in user questions within the cycle',
        quantity: 'Quantity:',
        clickHighFrequencyWords: 'Click High Frequency Words to View Details',
        transferToHuman: 'Transfer to Manual',
        transferToHumanTip: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        transferToHumanNumber: 'Transfer to Human Number ',
        day1: 'Day',
        week1: 'Week',
        month1: 'Month',
        before: 'Before',
        viewDetails: 'View Details',
        notKnowledgeBase: 'Miss Knowledge Base',
        notKnowledgeBaseTip: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        notKnowledgeBaseNumber: 'Miss Knowledge Base Count',
        times: 'Times',
        conversationNumber1: 'Conversation Number',
        conversationNumber1Tip: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        scoreConsumption: 'Credits Consumption',
        scoreConsumptionTip: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        selectChannel: 'Select Channel',
        scoreConsumptionTip1: 'Credits Consumption',
        cumulativeConsumption: 'Cumulative Usage',
        score: 'Credits',
        userCount: 'User Count',
        userCountTip: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        selectUser: 'Select User',
        userCountTip1: 'The number of times users trigger a transfer to human in conversations with your application or workflow within the cycle',
        userCount1: 'User Count ',
        total: 'Total ',
        export: 'Export',
        appName: 'App Name',
        question: 'Question',
        answer: 'Answer',
        keyword: 'Keyword',
        model: 'Model/Plugin',
        useTime: 'Use Time',
        view: 'View',
        useDetails: 'Use Details',
        typeTip: 'Type ',
        timeTip: 'Time ',
        modelTip: 'Model：',
        keywordTip: 'Keyword ',
        knowledgeBaseTip: 'Knowledge Base ',
        hitNumber: 'Hit Number',
        requestTip: 'Request ',
        resultTip: 'Result ',
        noData: 'No Data',
        exportHighFrequencyWordRecord: 'High Frequency Word Record Export',
        totalTip: 'Total ',
        source: 'Source',
        type: 'Type',
        prompt: 'Prompt',
        replyTextO: 'Reply Text O',
        triggerType: 'Trigger Type',
        triggerWord: 'Trigger Word',    
        triggerTypeTip: 'Trigger Type ',
        triggerWordTip: 'Trigger Word ',
        intention: 'Intention',
        keywords: 'Keywords',
        workflow: 'Workflow',
        exportNotHitKnowledgeRecord: 'Not Hit Knowledge Record Export',
        modelTitle: 'Model',
        pluginTitle: 'Plugin',
        knowledgeBaseTitle: 'Knowledge',
        workflowTitle: 'Workflow',
        knowledgeBaseImport: 'Knowledge Import',
        replyText: 'Reply Text',
        operation: 'Operation',
    }
}